var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVerifyEmail = function SvgVerifyEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "mail (1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6bb00",
    d: "M15.138 18.197 2.316 27.719l13.432 16.978Z",
    "data-name": "Path 19214"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6bb00",
    d: "m64.804 18.197-.609 26.5 13.432-16.981Z",
    "data-name": "Path 19215"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d3ffe2",
    d: "M66 2.345v57.62a2.332 2.332 0 0 1-2.364 2.345H16.364A2.332 2.332 0 0 1 14 59.966V2.345A2.332 2.332 0 0 1 16.364 0h47.273A2.332 2.332 0 0 1 66 2.345",
    "data-name": "Path 19216"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd000",
    d: "M79.156 28.806c-.047 0-1.5-1.126-1.5-1.126l-3.891 2.908-32.359 24.159a2.174 2.174 0 0 1-2.812 0L6.235 30.588 2.344 27.68s-1.453 1.126-1.5 1.126A2.32 2.32 0 0 0 0 30.588v42.375a7.024 7.024 0 0 0 7.031 7.036h65.938A7.024 7.024 0 0 0 80 72.963V30.588a2.32 2.32 0 0 0-.844-1.782",
    "data-name": "Path 19224"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4769",
    transform: "translate(-.029 26.023)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#22cb5b",
    "data-name": "Ellipse 307",
    transform: "translate(25.029 -18.023)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    d: "M37.769 2.393h-.026a.994.994 0 0 1-.7-.314l-3.008-3.241a.93.93 0 0 1 .073-1.342 1 1 0 0 1 1.384.072l2.318 2.5 7.633-7.394a1 1 0 0 1 1.386 0 .928.928 0 0 1 0 1.343l-8.364 8.1a.994.994 0 0 1-.696.276Z",
    "data-name": "Path 2486"
  })))));
};
export default SvgVerifyEmail;